import { useEffect, useState } from 'react';
import { TResultTanquerayProps } from '../type';
import { useAppStore, useCmsStore, useDevice, useFlavours } from '@/components/AppHooks';
import { useRouter } from 'next/navigation';
import { Loading } from '@/components/shared/Loading';
import { DdpCta } from '@/components/shared/DdpCta';
import { SmallCardList } from './smallCard';
import { BigCard } from './bigCard';
import { IconAdd } from '@/components/icon/tanqueray';
import { IconInfo } from '@/components/icon/master';
import { TanquerayCocktailList } from '@/components/shared/Tanqueray/TanqueryCocktailList';
import { Popup } from '@/components/shared/Popup';
import { getRecommendation } from '../api';
import { getCocktailByIds } from '@/shared/utils';
import { tracking } from '@/shared/tracking';
export function ResultsTanqueray(props: TResultTanquerayProps) {
    const { loading, titleHero, titleOtherDreamer, descriptionOtherDreamer, profileTitle, titleMoreCocktails, matchText, discoverCTA, cTAShowMore, cTARestart } = props
    const appStore = useAppStore()
    const { answer, results, secondResults, isReady } = appStore
    const router = useRouter()
    const flavours = useFlavours()
    const { isDesktop } = useDevice()
    const [clickedShowMore, setClickedShowMore] = useState(false)
    const [pageLoading, setPageLoading] = useState(true)
    const { locale, localeData: {
        topLabelTanqueray
    }, storeConfig } = useCmsStore()!
    const { isReady: storeIsReady } = storeConfig
    useEffect(() => {
        if (isReady === undefined || !storeIsReady) return
        if (!answer.atmosphere) {
            router.replace(`/${locale}/quiz${location.search}`);
            return
        }
        if (!results?.cocktailRecommendations) {
            setPageLoading(true)
            getRecommendation({
                appStore,
                storeConfig
            }).then(() => {
            })
        }
    }, [isReady, storeIsReady, answer.atmosphere, locale])
    useEffect(() => {
        if (!results || !secondResults) return;
        tracking({
            "event": "custom_event",
            "event_name": "quiz_complete",
            "step": "success"
        })
        Promise.allSettled([getCocktailByIds(secondResults!.cocktailRecommendations!.map((item) => item.cocktailId), 'secondCocktailList'), getCocktailByIds(results!.cocktailRecommendations.map((item) => item.cocktailId))]).finally(() => {
            setTimeout(() => {
                setPageLoading(false)
            }, 0);
        })
    }, [results, secondResults])
    const [selectedFlavor, setSelectedFlavor] = useState('');
    const [tips, setTips] = useState<{
        show: boolean,
        content?: string,
        flavor?: string,
        index?: number,
        left?: number,
    }>({
        show: false,
        flavor: '',
        index: -1,
        left: 0,
    });

    return <div className="page-tanqueray-results tanqueray-grid">
        <Loading show={(pageLoading && props.loading !== null)} loading={loading[0]} />
        {/* <Loading show={true} loading={loading[0]} /> */}
        {
            !pageLoading && <>
                <div className='title-container'>
                    <div className='top-label'>{topLabelTanqueray}</div>
                    <h1 className="title">{titleHero}</h1>
                </div>
                <BigCard {...props} />
                <div className='small-card-container'>
                    <div className='top-wrapper'>
                        <div className='smallCard-title'>{titleOtherDreamer}</div>
                        <div className='smallCard-desc' dangerouslySetInnerHTML={{ __html: descriptionOtherDreamer }}></div>
                    </div>
                    <SmallCardList {...props} />

                </div>
                <div className='flavor-container'>
                    <div className='flavour-title'>{titleMoreCocktails}</div>
                    <div className='flavour-list-wrapper'>
                        <div className='flavour-list-top-label'>{profileTitle}</div>
                        <div className='flavour-action-wrapper'>
                            <div className='flavour-list'>
                                {
                                    results?.consumerTopFlavors.slice(0, 3).map((item, index) => (
                                        <div key={item} className={`flavor-tag group`} onClick={() => {
                                            if (innerWidth < 1024) {
                                                setSelectedFlavor(item)
                                            }
                                        }}
                                            onMouseEnter={(e) => {
                                                if (innerWidth >= 1024) {
                                                    let target = e.target as HTMLElement
                                                    if (!target.classList.contains('flavor-tag')) {
                                                        target = target.closest('.flavor-tag') as HTMLElement
                                                    }
                                                    const parent = target.parentElement as HTMLElement
                                                    const { left: parentLeft } = parent.getBoundingClientRect()
                                                    const { width, left } = target.getBoundingClientRect()
                                                    setTips({
                                                        ...tips,
                                                        show: true,
                                                        flavor: item,
                                                        index: index,
                                                        left: (left - parentLeft) + width / 2,
                                                    })
                                                }

                                            }} onMouseLeave={() => {
                                                if (innerWidth >= 1024) {
                                                    setTips({
                                                        ...tips,
                                                        show: false,
                                                    })
                                                }
                                            }}  >
                                            <span className='text'>{
                                                flavours.find((fitem) => fitem.flavourID === item)?.flavourName ?? item
                                            }</span>
                                            <IconInfo className='icon-info' />

                                        </div>
                                    ))
                                }

                            </div>
                            <div className={`flavor-tips-wrapper tips-${tips.index} ${tips.show ? 'show' : 'hide'}`} style={{
                                '--left': `${tips.left}px`
                            } as React.CSSProperties}>
                                {
                                    flavours.find((item) => item.flavourName === tips.flavor || item.flavourID === tips.flavor)?.flavourDescription
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <div className='result-container'>
                    {
                        results && results?.cocktailRecommendations.length > 0 && <TanquerayCocktailList cta={discoverCTA} matchText={matchText} cocktailList={results.cocktailRecommendations.slice(0, clickedShowMore ? results.cocktailRecommendations.length : 3)} />
                    }

                    <div className='cta-wrapper'>
                        {
                            cTAShowMore && <DdpCta className='btn-show-more black nohover' disabled={clickedShowMore} cta={{
                                text: cTAShowMore,
                                show: true,
                                url: ''
                            }} onClick={() => {
                                setClickedShowMore(true)
                                tracking({
                                    "event": "in_page_button",
                                    "click_text": "Show More",
                                    "destination_page_path": location.pathname,
                                    "link_url": location.href,
                                    "detail": "Show More"
                                })
                            }} >
                                <IconAdd />
                            </DdpCta>
                        }
                        {
                            cTARestart && cTARestart.map((item) => (
                                <DdpCta className='btn-restart' key={item.text} cta={item} onClick={() => {
                                    tracking({
                                        "event": "in_page_button",
                                        "click_text": "Start Again",
                                        "destination_page_path": location.pathname,
                                        "link_url": location.href,
                                        "detail": "Start Again"
                                    })
                                }} />
                            ))
                        }

                    </div>
                </div>
            </>
        }

        <Popup className='tanqueray-flavor-popup-content' show={selectedFlavor !== '' && !isDesktop} onClose={() => setSelectedFlavor('')} headSlot={<div className='result-popup-header-title'>{
            flavours.find((fitem) => fitem.flavourID === selectedFlavor)?.flavourName ?? selectedFlavor
        }</div>} >
            <div className='flavour-title'>{
                flavours.find((fitem) => fitem.flavourID === selectedFlavor)?.flavourName ?? selectedFlavor
            }</div>
            <div className='flavour-desc' dangerouslySetInnerHTML={{ __html: flavours.find((item) => item.flavourID === selectedFlavor)?.flavourDescription || '' }}></div>
        </Popup>
    </div>
}